const CampaignStatusEnum = {
    RUNNING: "Running",
    REJECTED: "Rejected",
    AWAITING: "Awaiting",
    INACTIVE: "Inactive",
    SCHEDULED: "Scheduled",
    FINISHED: "Finished",
}

export default CampaignStatusEnum;